import area from "@turf/area";
import { SelectionFeature } from "src/js/stores/map/store";

export function useMaxSelectionArea(selection: SelectionFeature, maxAreaConstraintHectares: number) {
  const MAX_AREA_CONSTRAINT_METERS = maxAreaConstraintHectares * 10000;
  const selectionGeometry = selection.feature?.geometry;
  const selectionFeatureArea = selectionGeometry ? area(selectionGeometry) : 0;

  const exceedsMaximumAreaConstraint = selectionFeatureArea > MAX_AREA_CONSTRAINT_METERS;

  return { exceedsMaximumAreaConstraint };
}
